import { Channel, Group, Skill, Team } from '@contact/upgrade';

export type ResponseId = string;
export type RequestId = number | string;
export type TransferKey = ResponseId | RequestId[];
export type TransferResult = [string | number, boolean];

// key for transfer sould be :
// - a string for response id usage PHONE
// - a array of string or number for request eptica id usage MAIL
export function isResponseId(key: TransferKey): key is string {
  return typeof key === 'string';
}

export function toKey(key: TransferKey): string {
  return isResponseId(key) ? `responseId_${key}` : `requestId_${JSON.stringify(key)}`;
}

export enum TransferType {
  ACCOMPANIED,
  NOT_ACCOMPANIED,
  CONTACT = 'contact',
  DIRECTORY = 'directory',
}

/*
export enum TransferTarget {
  SKILL,
  AGENT,
  CORRESPONDENT,
  COMPOSITE,
  FREE_NUMBER,
  EXTERNAL_CENTER,
  TEAM,
  AGENT_ASSISTANCE_BY_SKILL,
}
*/

export enum TransferTarget {
  SKILL = 'SKILL',
  AGENT = 'AGENT',
  CORRESPONDENT = 'CORRESPONDENT',
  COMPOSITE = 'COMPOSITE',
  FREE_NUMBER = 'FREE_NUMBER',
  EXTERNAL_CENTER = 'EXTERNAL_CENTER',
  TEAM = 'TEAM',
  AGENT_ASSISTANCE_BY_SKILL = 'AGENT_ASSISTANCE_BY_SKILL',
}

export enum TransferHistorySelectionStatus {
  SELECTABLE = 'SELECTABLE',
  DISABLED = 'DISABLED',
  NONE_OR_ALL = 'NONE_OR_ALL',
}

export interface ITransfer {
  key: TransferKey;
  channel: Channel;
  type: TransferType;
  targetType: TransferTarget;
  target?: any;
  source?: any;
  comment: string;
  rejected: boolean;
  ignoreConference?: boolean;
  sendKnowledgeBaseNotification: boolean;
  blind?: boolean;
  includedMessagesId?: string[];
}

export interface ITargetSelectionCsr {
  uuid: string;
  name: string;
  email: string;
  login: string;
  firstName: string;
  lastName: string;
}

export interface ITargetSelection {
  skills?: Skill[];
  teams?: Team[];
  groups?: Group[];
  csr?: ITargetSelectionCsr;
}
